import { applyTextDiff, updateBlockProps } from "@worktools/shared";
import { useBlockProps, useYText } from "../../sync/hooks";
import { useBoard } from "../../sync/BoardContext";

export function CardBlock({ blockId }: { blockId: string }) {
  const { doc } = useBoard();
  const props = useBlockProps<{ title: string; badge: string }>(blockId);
  const { text, value } = useYText(blockId, "text");

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10, height: "100%" }}>
      <input
        type="text"
        value={props.badge ?? ""}
        placeholder="LABEL"
        onChange={(event) => updateBlockProps(doc, blockId, { badge: event.target.value.toUpperCase() })}
        className="label"
        style={{ border: "none", background: "none", padding: 0, width: "100%" }}
      />
      <input
        type="text"
        value={props.title ?? ""}
        placeholder="Titel"
        onChange={(event) => updateBlockProps(doc, blockId, { title: event.target.value })}
        style={{ border: "none", background: "none", padding: 0, fontSize: 18, fontWeight: 500 }}
      />
      <textarea
        value={value}
        placeholder="Beschreibung…"
        onChange={(event) => text && applyTextDiff(text, event.target.value)}
        style={{
          flex: 1,
          border: "none",
          background: "none",
          resize: "none",
          outline: "none",
          padding: 0,
          fontSize: 13,
          lineHeight: 1.6,
          color: "var(--ink-soft)",
        }}
      />
    </div>
  );
}
